import React from "react";

interface AuthAlertProps {
  kind: "error" | "success";
  /** Plain text, or the JSON object of field errors the API returns on validation failures. */
  message: string;
}

/** Splits an API error into one line per message. Validation errors arrive as a JSON object. */
const toLines = (message: string): string[] => {
  try {
    const parsed = JSON.parse(message);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return Object.values(parsed)
        .flat()
        .map((m: unknown) => String(Array.isArray(m) ? m[0] : m));
    }
  } catch {
    /* not JSON */
  }
  return [message];
};

const AuthAlert: React.FC<AuthAlertProps> = ({ kind, message }) => (
  <div className={`auth-alert auth-alert-${kind}`} role={kind === "error" ? "alert" : "status"}>
    {toLines(message).map((line, i) => (
      <p key={i}>{line}</p>
    ))}
  </div>
);

export default AuthAlert;
